const KALODATA_PRODUCT_DETAIL_HOSTS = new Set(["www.kalodata.com", "kalodata.com"]);

/**
 * 是否应上报「从 Kalodata 商品详情页直接进入视频创作页」：
 * - 依赖 document.referrer（对方站点 Referrer-Policy 过严时可能为空，此时无法判定）
 * - 仅当本次**整页加载**的地址就是 /video-creating 时成立，避免先打开站内其它页再点进创作页的误报
 */
export function shouldReportVideoCreatingFromKalodataProduct(): boolean {
  if (typeof document === "undefined") {
    return false;
  }
  const ref = document.referrer;
  if (!ref) {
    return false;
  }
  try {
    const refUrl = new URL(ref);
    if (!KALODATA_PRODUCT_DETAIL_HOSTS.has(refUrl.hostname)) {
      return false;
    }
  } catch {
    return false;
  }
  return true;
}
